import writeXlsxFile from "write-excel-file";

export const getAccrualTotals = async (
  startDate,
  endDate,
  projectId,
  JwtToken,
  setAuthStatus,
  navigate,
) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", "Bearer " + JwtToken);

  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND}/pc/project-accrual-totals/${projectId}?start_date=${startDate}&end_date=${endDate}`,
      {
        method: "GET",
        headers,
      },
    );

    if (!res.ok) {
      if (res.status === 401) {
        setAuthStatus(false);
        navigate("/login");
        return { ft: null, st: null, err: "Unauthorized" };
      }

      return { ft: null, st: null, err: "Something went wrong" };
    }

    const data = await res.json();
    return {
      freightTotals: data.freight_accruals,
      sandTotals: data.sand_accruals,
      err: null,
    };
  } catch (error) {
    console.log(error);
    return { ft: null, st: null, err: "Error" };
  }
};

export const DownloadAccrual = async (
  loads,
  accruedAssetLoads,
  accName,
  jobName,
  freightTotals,
  sandTotals,
) => {
  // parse delivered date
  // replace periods from job name

  let newJobName = jobName.replace(/[/\\]/g, "-");
  let newAccName = accName.replace(/[/\\]/g, "-");

  const ErrorHandler = (error) => {
    return error.message;
  };

  const DeliveredOn = (d) => {
    try {
      // Parse the input date string into a JavaScript Date object
      const date = new Date(d);

      // Use Intl.DateTimeFormat to convert to Central Time
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Chicago", // Central Time Zone
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      // Format the date
      const formattedDate = formatter.format(date);
      return formattedDate;
    } catch (error) {
      return ErrorHandler(error);
    }
  };
  
  const carriers = {};
  const sand_pos = {};
  const columns = [
    { width: 2 },
    { width: 30 },
    { width: 35 },
    { width: 30 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 20 },
    { width: 30 },
    { width: 30 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 35 },
    { width: 30 },
  ];
  const blankRow = [{}];
  let data = [blankRow];
  const allFreightTotals = {
    weight_billed: 0,
    weight_not_billed: 0,
    freight_rev_rate: "",
    freight_billed: 0,
    freight_not_billed: 0,
    fsc_rev_rate: "",
    fsc_billed: 0,
    fsc_not_billed: 0,
    weight_received: 0,
    weight_not_received: 0,
    freight_cost_rate: "",
    freight_received: 0,
    freight_not_received: 0,
    fsc_cost_rate: "",
    fsc_received: 0,
    fsc_not_received: 0,
  };
  if (freightTotals) {
    data.push([
      {},
      {
        value: "Freight PO Totals",
        fontWeight: "bold",
        fontSize: 20,
        align: "center",
        span: 17,
      },
    ]);
    data.push([
      {},
      {
        value: "Carrier",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Billed",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Not Billed",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Freight Rev Rate",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Freight Billed $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Freight Not Billed $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "FSC Rev Rate",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "FSC Billed $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "FSC Not Billed $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Received",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Not Received",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Freight Cost Rate",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Freight Received $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Freight Not Received $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "FSC Cost Rate",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "FSC Received $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "FSC Not Received $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    ]);

    freightTotals.forEach((t) => {
      if (!carriers[t.vendor_name]) {
        carriers[t.vendor_name] = [
          {
            weight_billed: t.weight_billed,
            weight_not_billed: t.weight_not_billed,
            freight_rev_rate: t.freight_rev_rate,
            freight_billed: t.freight_billed,
            freight_not_billed: t.freight_not_billed,
            fsc_rev_rate: t.fsc_rev_rate,
            fsc_billed: t.fsc_billed,
            fsc_not_billed: t.fsc_not_billed,
            weight_received: t.weight_received,
            weight_not_received: t.weight_not_received,
            freight_cost_rate: t.freight_cost_rate,
            freight_received: t.freight_received,
            freight_not_received: t.freight_not_received,
            fsc_cost_rate: t.fsc_cost_rate,
            fsc_received: t.fsc_received,
            fsc_not_received: t.fsc_not_received,
          },
        ];
      } else {
        const c = carriers[t.vendor_name].filter(
          (x) => x.freight_rev_rate === t.freight_rev_rate,
        );
        if (c.length > 0) {
          c[0].weight_billed = c[0].weight_billed + t.weight_billed;
          c[0].weight_not_billed = c[0].weight_not_billed + t.weight_not_billed;
          c[0].freight_billed = c[0].freight_billed + t.freight_billed;
          c[0].freight_not_billed =
            c[0].freight_not_billed + t.freight_not_billed;
          c[0].fsc_billed = c[0].fsc_billed + t.fsc_billed;
          c[0].fsc_not_billed = c[0].fsc_not_billed + t.fsc_not_billed;
          c[0].weight_received = c[0].weight_received + t.weight_received;
          c[0].weight_not_received =
            c[0].weight_not_received + t.weight_not_received;
          c[0].freight_received = c[0].freight_received + t.freight_received;
          c[0].freight_not_received =
            c[0].freight_not_received + t.freight_not_received;
          c[0].fsc_received = c[0].fsc_received + t.fsc_received;
          c[0].fsc_not_received = c[0].fsc_not_received + t.fsc_not_received;
        } else {
          carriers[t.vendor_name].push({
            weight_billed: t.weight_billed,
            weight_not_billed: t.weight_not_billed,
            freight_rev_rate: t.freight_rev_rate,
            freight_billed: t.freight_billed,
            freight_not_billed: t.freight_not_billed,
            fsc_rev_rate: t.fsc_rev_rate,
            fsc_billed: t.fsc_billed,
            fsc_not_billed: t.fsc_not_billed,
            weight_received: t.weight_received,
            weight_not_received: t.weight_not_received,
            freight_cost_rate: t.freight_cost_rate,
            freight_received: t.freight_received,
            freight_not_received: t.freight_not_received,
            fsc_cost_rate: t.fsc_cost_rate,
            fsc_received: t.fsc_received,
            fsc_not_received: t.fsc_not_received,
          });
        }
      }
      allFreightTotals.weight_billed =
        allFreightTotals.weight_billed + t.weight_billed;
      allFreightTotals.weight_not_billed =
        allFreightTotals.weight_not_billed + t.weight_not_billed;
      allFreightTotals.freight_billed =
        allFreightTotals.freight_billed + t.freight_billed;
      allFreightTotals.freight_not_billed =
        allFreightTotals.freight_not_billed + t.freight_not_billed;
      allFreightTotals.fsc_billed = allFreightTotals.fsc_billed + t.fsc_billed;
      allFreightTotals.fsc_not_billed =
        allFreightTotals.fsc_not_billed + t.fsc_not_billed;
      allFreightTotals.weight_received =
        allFreightTotals.weight_received + t.weight_received;
      allFreightTotals.weight_not_received =
        allFreightTotals.weight_not_received + t.weight_not_received;
      allFreightTotals.freight_received =
        allFreightTotals.freight_received + t.freight_received;
      allFreightTotals.freight_not_received =
        allFreightTotals.freight_not_received + t.freight_not_received;
      allFreightTotals.fsc_received =
        allFreightTotals.fsc_received + t.fsc_received;
      allFreightTotals.fsc_not_received =
        allFreightTotals.fsc_not_received + t.fsc_not_received;
    });
  }
  
  if (carriers && Object.keys(carriers).length > 0) {
    for (const [key, val] of Object.entries(carriers)) {
      let totals = {
        weight_billed: 0,
        weight_not_billed: 0,
        freight_rev_rate: "",
        freight_billed: 0,
        freight_not_billed: 0,
        fsc_rev_rate: "",
        fsc_billed: 0,
        fsc_not_billed: 0,
        weight_received: 0,
        weight_not_received: 0,
        freight_cost_rate: "",
        freight_received: 0,
        freight_not_received: 0,
        fsc_cost_rate: "",
        fsc_received: 0,
        fsc_not_received: 0,
      };
      for (let i = 0; i < val.length; i++) {
        totals.weight_billed = totals.weight_billed + val[i].weight_billed;
        totals.weight_not_billed =
          totals.weight_not_billed + val[i].weight_not_billed;
        totals.freight_billed = totals.freight_billed + val[i].freight_billed;
        totals.freight_not_billed =
          totals.freight_not_billed + val[i].freight_not_billed;
        totals.fsc_billed = totals.fsc_billed + val[i].fsc_billed;
        totals.fsc_not_billed = totals.fsc_not_billed + val[i].fsc_not_billed;
        totals.weight_received =
          totals.weight_received + val[i].weight_received;
        totals.weight_not_received =
          totals.weight_not_received + val[i].weight_not_received;
        totals.freight_received =
          totals.freight_received + val[i].freight_received;
        totals.freight_not_received =
          totals.freight_not_received + val[i].freight_not_received;
        totals.fsc_received = totals.fsc_received + val[i].fsc_received;
        totals.fsc_not_received =
          totals.fsc_not_received + val[i].fsc_not_received;
        let newRow = [];
        if (i === 0) {
          newRow.push(
            {},
            {
              value: key,
              fontSize: 12,
              align: "center",
              leftBorderStyle: "thin",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            },
          );
        } else {
          newRow.push(
            {},
            {
              value: "",
              fontSize: 12,
              align: "center",
              leftBorderStyle: "thin",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            },
          );
        }
        for (const [, ov] of Object.entries(val[i])) {
          newRow.push({
            value: parseFloat(ov.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        }
        data.push(newRow);
      }
      let totalRow = [];
      totalRow.push(
        {},
        {
          value: `${key} - Totals`,
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      );
      for (const [, ct] of Object.entries(totals)) {
        if (ct !== "") {
          totalRow.push({
            value: parseFloat(ct.toFixed(2)),
            fontSize: 12,
            type: Number,
            fontWeight: "bold",
            align: "center",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        } else {
          totalRow.push({
            value: ct,
            fontSize: 12,
            fontWeight: "bold",
            align: "center",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        }
      }
      data.push(totalRow);
    }

    const allFreightTotalsRow = [];
    allFreightTotalsRow.push(
      {},
      {
        value: "Totals",
        fontSize: 14,
        align: "center",
        fontWeight: "bold",
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    );
    for (const [, t] of Object.entries(allFreightTotals)) {
      if (t !== "") {
        allFreightTotalsRow.push({
          value: parseFloat(t.toFixed(2)),
          fontSize: 14,
          type: Number,
          fontWeight: "bold",
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        });
      } else {
        allFreightTotalsRow.push({
          value: t,
          fontSize: 14,
          fontWeight: "bold",
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        });
      }
    }
    data.push(allFreightTotalsRow);
  }
  
  const allSandTotals = {
    weight_billed: 0,
    weight_not_billed: 0,
    sand_rev_rate: "",
    sand_billed: 0,
    sand_not_billed: 0,
    weight_received: 0,
    weight_not_received: 0,
    sand_cost_rate: "",
    sand_received: 0,
    sand_not_received: 0,
  };
  if (sandTotals) {
    data.push(blankRow);
    data.push([
      {},
      {
        value: "Sand PO Totals",
        fontWeight: "bold",
        fontSize: 20,
        align: "center",
        span: 12,
      },
    ]);
    data.push([
      {},
      {
        value: "Terminal",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Purchase Order",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Billed",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Not Billed",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Sand Rev Rate",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Sand Billed $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Sand Not Billed $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Received",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Weight Not Received",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Sand Cost Rate",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Sand Received $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "Sand Not Received $",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    ]);

    sandTotals.forEach((t) => {
      if (!sand_pos[t.vendor_name]) {
        sand_pos[t.vendor_name] = [
          {
            purchase_order: t.purchase_order,
            weight_billed: t.weight_billed,
            weight_not_billed: t.weight_not_billed,
            sand_rev_rate: t.sand_rev_rate,
            sand_billed: t.sand_billed,
            sand_not_billed: t.sand_not_billed,
            weight_received: t.weight_received,
            weight_not_received: t.weight_not_received,
            sand_cost_rate: t.sand_cost_rate,
            sand_received: t.sand_received,
            sand_not_received: t.sand_not_received,
          },
        ];
      } else {
        sand_pos[t.vendor_name].push({
          purchase_order: t.purchase_order,
          weight_billed: t.weight_billed,
          weight_not_billed: t.weight_not_billed,
          sand_rev_rate: t.sand_rev_rate,
          sand_billed: t.sand_billed,
          sand_not_billed: t.sand_not_billed,
          weight_received: t.weight_received,
          weight_not_received: t.weight_not_received,
          sand_cost_rate: t.sand_cost_rate,
          sand_received: t.sand_received,
          sand_not_received: t.sand_not_received,
        });
      }
      allSandTotals.weight_billed =
        allSandTotals.weight_billed + t.weight_billed;
      allSandTotals.weight_not_billed =
        allSandTotals.weight_not_billed + t.weight_not_billed;
      allSandTotals.sand_billed = allSandTotals.sand_billed + t.sand_billed;
      allSandTotals.sand_not_billed =
        allSandTotals.sand_not_billed + t.sand_not_billed;
      allSandTotals.weight_received =
        allSandTotals.weight_received + t.weight_received;
      allSandTotals.weight_not_received =
        allSandTotals.weight_not_received + t.weight_not_received;
      allSandTotals.sand_received =
        allSandTotals.sand_received + t.sand_received;
      allSandTotals.sand_not_received =
        allSandTotals.sand_not_received + t.sand_not_received;
    });
  }

  if (sand_pos && Object.keys(sand_pos).length > 0) {
    for (const [key, val] of Object.entries(sand_pos)) {
      let totals = {
        weight_billed: 0,
        weight_not_billed: 0,
        sand_rev_rate: "",
        sand_billed: 0,
        sand_not_billed: 0,
        weight_received: 0,
        weight_not_received: 0,
        sand_cost_rate: "",
        sand_received: 0,
        sand_not_received: 0,
      };
      for (let i = 0; i < val.length; i++) {
        totals.weight_billed = totals.weight_billed + val[i].weight_billed;
        totals.weight_not_billed =
          totals.weight_not_billed + val[i].weight_not_billed;
        totals.sand_billed = totals.sand_billed + val[i].sand_billed;
        totals.sand_not_billed =
          totals.sand_not_billed + val[i].sand_not_billed;
        totals.weight_received =
          totals.weight_received + val[i].weight_received;
        totals.weight_not_received =
          totals.weight_not_received + val[i].weight_not_received;
        let newRow = [];
        if (i === 0) {
          newRow.push(
            {},
            {
              value: key,
              fontSize: 12,
              align: "center",
              leftBorderStyle: "thin",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            },
          );
        } else {
          newRow.push(
            {},
            {
              value: "",
              fontSize: 12,
              align: "center",
              leftBorderStyle: "thin",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            },
          );
        }
        for (const [, ov] of Object.entries(val[i])) {
          if (typeof ov === "string") {
            newRow.push({
              value: ov,
              fontSize: 12,
              align: "center",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            });
          } else {
            newRow.push({
              value: parseFloat(ov.toFixed(2)),
              fontSize: 12,
              type: Number,
              align: "center",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            });
          }
        }
        data.push(newRow);
      }
      let totalRow = [];
      totalRow.push(
        {},
        {
          value: `${key} - Totals`,
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      );
      for (const [, ct] of Object.entries(totals)) {
        if (ct !== "") {
          totalRow.push({
            value: parseFloat(ct.toFixed(2)),
            fontSize: 12,
            type: Number,
            fontWeight: "bold",
            align: "center",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        } else {
          totalRow.push({
            value: ct,
            fontSize: 12,
            fontWeight: "bold",
            align: "center",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        }
      }
      data.push(totalRow);
    }
    const allSandTotalsRow = [];
    allSandTotalsRow.push(
      {},
      {
        value: "Totals",
        fontSize: 14,
        align: "center",
        fontWeight: "bold",
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: "",
        fontSize: 14,
        align: "center",
        fontWeight: "bold",
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    );
    for (const [, t] of Object.entries(allSandTotals)) {
      if (t !== "") {
        allSandTotalsRow.push({
          value: parseFloat(t.toFixed(2)),
          fontSize: 14,
          type: Number,
          fontWeight: "bold",
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        });
      } else {
        allSandTotalsRow.push({
          value: t,
          fontSize: 14,
          fontWeight: "bold",
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        });
      }
    }
    data.push(allSandTotalsRow);
  }

  data.push(blankRow, blankRow);

  data.push([
    {},
    {
      value: "Freight Loads",
      fontWeight: "bold",
      fontSize: 20,
      align: "center",
      span: 19,
    },
  ]);
  const loadsHeader = [
    {},
    {
      value: "Load No",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Delivery Date",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Carrier",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Terminal",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Product",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "PO Number",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Ticket No",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Approved Mileage",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Net Weight (tons)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Freight Rev ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Freight Cost ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Fuel Surcharge Rev ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Fuel Surcharge Cost ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Sand Rev ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Sand Cost ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Total Rev ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Total Cost ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Customer Not Billed",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Freight Not Received",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
    {
      value: "Sand Not Received",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    },
  ];
  data.push(loadsHeader);

  loads.forEach((load) => {
    let delivered = DeliveredOn(load.delivered_date);

    let newLoad = [
      {},
      {
        value: load.load_no,
        fontSize: 12,
        align: "center",
      },
      {
        value: delivered,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.carrier_name,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.terminal_name,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.product_name,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.po_number,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.ticket_number,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.approved_mileage,
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.weight_tons.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
      },
      {
        value: parseFloat(load.freight_rev.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.freight_cost.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.fsc_rev.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.fsc_cost.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.sand_rev.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.sand_cost.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.total_rev.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: parseFloat(load.total_cost.toFixed(2)),
        type: Number,
        fontSize: 12,
        align: "center",
      },
      {
        value: load.customer_invoice_id === 0 ? "X" : "",
        fontSize: 12,
        align: "center",
      },
      {
        value: load.vendor_invoice_id === 0 ? "X" : "",
        fontSize: 12,
        align: "center",
      },
      {
        value: load.sand_invoice_id === 0 ? "X" : "",
        fontSize: 12,
        align: "center",
      },
    ];
    data.push(newLoad);
  });

  data.push(blankRow, blankRow);
  if (accruedAssetLoads && accruedAssetLoads.length > 0) {

    data.push([
      {},
      {
        value: "Asset Loads",
        fontWeight: "bold",
        fontSize: 20,
        align: "center",
        span: 12,
      },
    ]);
    const assetLoadsheader = [
      {},
      {
        value: "Load No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Delivery Date",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Approved Mileage",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Total Rev ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Total Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Customer Not Billed",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight Not Received",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];
    data.push(assetLoadsheader);
    accruedAssetLoads.forEach((load) => {
      let delivered = DeliveredOn(load.delivered_date);
  
      let newLoad = [
        {},
        {
          value: load.load_no,
          fontSize: 12,
          align: "center",
        },
        {
          value: delivered,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.approved_mileage,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.weight_tons,
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: load.freight_rev,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.freight_cost,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.fsc_rev,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.fsc_cost,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.total_rev,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.total_cost,
          type: Number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.customer_invoice_id === 0 ? "X" : "",
          fontSize: 12,
          align: "center",
        },
        {
          value: load.vendor_invoice_id === 0 ? "X" : "",
          fontSize: 12,
          align: "center",
        },
      ];
      data.push(newLoad);
    });
  }
  var fileName = `${newJobName} - ${newAccName}`;
  await writeXlsxFile(data, { columns, fileName });
};
